import { NgModule } from '@angular/core';
import { AuthModule, LogLevel, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';

import { UrlService } from 'app/core/http/url.service';

import { environment } from 'env/environment';

const authFactory = (urlService: UrlService) => {
  const mceConfig = {
    configId: environment.mceClientId,
    authority: environment.mceBase + '/LEAD/kh',
    authWellknownEndpointUrl: environment.mceBase + '/LEAD/.well-known/openid-configuration',
    redirectUrl: urlService.buildServerApiUrl('login', 'oidc'),
    clientId: environment.mceClientId,
    scope: 'openid profile email',
    postLogoutRedirectUri: window.location.origin + '/app/login',
    responseType: 'id_token',
    maxIdTokenIatOffsetAllowedInSeconds: 600,
    disableIatOffsetValidation: true,
    enableIdTokenExpiredValidationInRenew: false,
    issValidationOff: true,
    autoUserInfo: false,
    ignoreNonceAfterRefresh: true,
    logLevel: LogLevel.Error,
    silentRenew: false,
    useRefreshToken: false
  };

  const googleConfig = {
    authority: 'https://accounts.google.com',
    redirectUrl: `${window.location.origin}/app/oauth/google`,
    configId: environment.googleClientId,
    clientId: environment.googleClientId,
    scope: 'openid profile email',
    responseType: 'id_token token',
    silentRenew: false,
    useRefreshToken: false,
    historyCleanupOff: false,
    logLevel: LogLevel.Debug
  };

  return new StsConfigStaticLoader([mceConfig, googleConfig]);
};

@NgModule({
  imports: [
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [UrlService]
      }
    })
  ],
  exports: [AuthModule]
})
export class AuthConfigModule { }
